import * as yup from 'yup'

export const schema = yup.object().shape({
  coupon: yup.string(),
})

export default schema
